<app-header></app-header>
<section class="skills my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="FAQs-content-child">
                <div class="FAQs-content-child">
                    <div class="etiquette-content-header-container">
                        <h2 class="etiquette-header">Parking Etiquette</h2>
                    </div>
                    <div class="etiquette-text-container">
                        <p>Sharing parking is like a home; no one likes a loud, obnoxious, and untidy person living with them right? Well, the same rules apply to ParkUpp...</p>
                        <br />
                        <p>
                            We have intentionally created a parking community that promotes and encourages trust, respect as well as fairness to all users that have graciously joined our ParkUpp
                            family.
                        </p>
                        <br />
                        <p>We encourage propery owners to provide parking that is neat, secure and easily accessible to the parking user, creating a seamless and fun experience.</p>
                        <br />
                        <p>
                            We also encourage our parking user to respect and be considerate of the parking owners property in all aspects. Litter should be left in the trash can, noise should be kept
                            to a minimal and mindfulness of the security of the property should be kept at all times
                        </p>
                        <br />
                        <p>By simpy being a lekker person and following the simple parking etiquette, we are setting the stage for something really amazing.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
